const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

/** Names the region list doesn't use, or that read better short. */
const ALIASES: Readonly<Record<string, string>> = {
  "czech republic": "Tschechien",
  "the netherlands": "Niederlande",
  turkey: "Türkei",
  uk: "Vereinigtes Königreich",
  england: "England",
  "united states": "USA",
  "united states of america": "USA",
  usa: "USA",
};

let germanCountry: ReadonlyMap<string, string> | undefined;

/** Country name, English or German (lower-cased) → German, for every region the browser
 * knows, built once from `Intl.DisplayNames`. */
function germanCountries(): ReadonlyMap<string, string> {
  if (germanCountry) return germanCountry;
  const en = new Intl.DisplayNames(["en"], { type: "region", fallback: "none" });
  const de = new Intl.DisplayNames(["de"], { type: "region", fallback: "none" });
  const names = new Map<string, string>();
  for (const a of LETTERS) {
    for (const b of LETTERS) {
      const code = a + b;
      const english = en.of(code);
      const german = de.of(code);
      if (english && german) {
        names.set(english.toLowerCase(), german);
        names.set(german.toLowerCase(), german); // already German („Deutschland")
      }
    }
  }
  for (const [english, german] of Object.entries(ALIASES)) names.set(english, german);
  germanCountry = names;
  return names;
}

/** A candidate's stored „Stadt, Land" with the country in German (#152). Sources
 * write it in their own language („Germany" or „Deutschland"); a last part that
 * isn't a country is shown as stored. */
export function formatLocation(location: string | null | undefined): string {
  if (!location) return "";
  const parts = location.split(",").map((part) => part.trim());
  const german = germanCountries().get(parts.at(-1)!.toLowerCase());
  if (!german) return location;
  return [...parts.slice(0, -1), german].join(", ");
}

/** The country of a stored „Stadt, Land" in German, or null when its last
 * part isn't a country („Hamburg", „Remote (EU)"). The Anonym-Ansicht shows
 * this instead of the town (#146). */
export function countryOf(location: string | null | undefined): string | null {
  if (!location) return null;
  const last = location.split(",").at(-1)!.trim().toLowerCase();
  return germanCountries().get(last) ?? null;
}

/** Below this the distance would point at the town: it reads „unter 10 km". */
export const ANONYM_NEAR_DISTANCE_KM = 10;
